// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3wjx7","footer":"Form_footer__Kspm5"};